module.exports = __webpack_public_path__ + "img/instagram.b395e466.svg";